// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BPnR","content":"styles_content__H5Ncc","tableWrap":"styles_tableWrap__1ID8M"};